
export class UpdateViewSearch{
    static readonly type = '[APP STATE VIEW] UpdateViewSearch';

    constructor(public payload: string) {}

}

export class UpdateUserDetails{
    static readonly type = '[APP STATE USER] Update User';

    constructor(public payload: string) {}

}

export class UpdateToken{
    static readonly type = '[APP STATE TOKEN] Update Token';
    constructor(public payload: string) {}
}

export class FetchSessionUser{
    static readonly type = '[APP SESSION USER] Fetch and store session user';
    constructor(public payload: any) {}
}

export class UpdateSelectedTabInManage{
    static readonly type = '[UPDATE TAB IN MANAGE] Update selected tab In Manage';
    constructor(public payload: string) {}
}

export class CreateNetworkDiagram{
    static readonly type = '[CREATE NETWORK DIAGRAM] Create network digram in DB';
    constructor(public payload: any) {}
}

export class UpdateNetworkDiagram{
    static readonly type = '[UPDATE NETWORK DIAGRAM] Update network digram in DB';
    constructor(public payload: any, public idForEdit: string) {}
}

export class FetchNetworkDiagramById{
    static readonly type = '[FETCH NETWORK DIAGRAM META] Fetch network diagram meta - data  by id';
    constructor(public idForEdit: string) {}
}

export class FetchNetworkDiagramMeta{
    static readonly type = '[FETCH NETWORK DIAGRAM META] Fetch network diagram meta - data ';
    constructor(public payload: any) {}
}

export class ClearNetworkDiagramMeta{
    static readonly type = '[CLEAR NETWORK DIAGRAM META] Clear network diagram meta - data ';
    constructor() {}
}

export class LogoutUser{
    static readonly type = '[USER SESSION] Logout user';
    constructor() {}
}

export class DeleteNetworkDiagram{
    static readonly type = '[DELETE NETWORK DIAGRAM META] Delete network diagram';
    constructor(public idForDelete: string, public productId: string) {}
}
